import { format, formatDistanceToNow, isToday, isYesterday, parseISO } from "date-fns";
import { it } from "date-fns/locale";

export function formatDate(value: string | Date | null | undefined, fmt = "d MMM yyyy"): string {
  if (!value) return "—";
  const d = typeof value === "string" ? parseISO(value) : value;
  return format(d, fmt, { locale: it });
}

export function formatDateTime(value: string | Date | null | undefined): string {
  return formatDate(value, "d MMM yyyy, HH:mm");
}

export function formatRelative(value: string | Date | null | undefined): string {
  if (!value) return "—";
  const d = typeof value === "string" ? parseISO(value) : value;
  if (isToday(d)) return `oggi, ${format(d, "HH:mm")}`;
  if (isYesterday(d)) return `ieri, ${format(d, "HH:mm")}`;
  return formatDistanceToNow(d, { locale: it, addSuffix: true });
}

export function formatMonthLabel(value: string | Date): string {
  return formatDate(value, "MMMM yyyy");
}

export function formatEur(value: number, maximumFractionDigits = 0): string {
  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits,
  }).format(value);
}

export function initials(name: string | null | undefined, fallback = "?"): string {
  if (!name) return fallback;
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return fallback;
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
